<span class="verified-indicator" [class.is-verified]="verified()">
  <umss-icon [name]="iconName()" [size]="size()" />
  <span class="verified-indicator__label">{{ label() }}</span>
</span>
